import { Col, Row, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Modal, Input } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { LinkOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import AbhaLinkedFilter from "../AbhaFilter";
import { UserId } from "../../../utils";
import moment from "moment";
import { usePermission, useRights } from "../../../hooks/usePermission";
import { DashboardServices } from "../../../redux/Services";
import IMAGES from "../../../const/Image";
import {
  DownloadReport,
  DECODEBASE,
} from "../../../redux/Services/AbhaServices";
import Loader from "../DataReceived/loader";
import { KeyMaterialRequst } from "../../../redux/Services/AbhaServices";
import { AntLoadingButton } from "../../../component/LoadingButton";
const ConsentArtifactRequested = () => {
  const permission = usePermission("HIU Dashboard", "List");
  // Asking for a report starts a new consent request (needs Add)
  const rights = useRights("HIU Dashboard");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [isExpired, setisExpired] = useState(null);
  const hiuConsentArtifactRequested = useSelector(
    (state) => state.dashboard.CconsentGrantLogs || []
  );
  const totalhiuConsentArtifactRequested = useSelector(
    (state) => state.dashboard.totalCconsentGrantLogs || []
  );
  const CconsentGrantLogs = useSelector(
    (state) => state.dashboard.CconsentGrantLogs || []
  );
  const { mutate: fetchhiuConsentArtifactRequested, isLoading } = useMutation(
    (data) =>
      dispatch(
        DashboardServices.fetchCconsentGrantLogs({
          page: 1,
          limit: 40,
          ...data,
        })
      )
  );
  const [modal1Open, setModal1Open] = useState(false);
  const { mutate: fetchgetCardsLogsSearch } = useMutation((data) =>
    dispatch(DashboardServices.fetchgetCardsLogsSearch(data))
  );
  const { mutate: getDownloadReport, isLoading: loader1 } = useMutation(
    (data) => dispatch(DownloadReport(data, navigate))
  );
  const { mutate: decodeBase, isLoading: loader } = useMutation((data) =>
    dispatch(DECODEBASE(data, navigate))
  );
  const { mutate: KeyMaterialRequest, isLoading: addLoading } = useMutation(
    (data) => dispatch(KeyMaterialRequst(data, navigate))
  );
  const { mutateAsync: constentArtifactDetailsFetch } = useMutation((data) =>
    dispatch(DashboardServices.constentArtifactDetailsFetch(data, navigate))
  );
  const [askReport, setaskReport] = useState(false);
  const [raw, setRaw] = useState({});
  const [ModalNotify, setModalNotify] = useState(false);
  const [currentDate, setCurrentDate] = useState(
    moment().local().format("YYYY-MM-DD HH:mm:ss")
  );
  const DECODEBASEData = useSelector(
    (state) => state.abhaCreated.DECODEBASEData || []
  );
  const dataDecryption = useSelector(
    (state) => state.abhaCreated.DownloadReport || []
  );

  const [values, setValues] = useState({
    healthId: "",
  });
  const { search } = useLocation();
  const healthId = new URLSearchParams(search).get("healthId");
  // console.log(healthId)
  const handleFetchArtifactDetail = (consentRequestId, requestId) => {
    return constentArtifactDetailsFetch({
      consentRequestId,
      "x-request-id": requestId,
    });
  };
  const [keyMaterial, setKeyMaterial] = useState({
    privateKey: "DpstJVIUMbG4W0oQAwvke7BHqdmS/6XMC733YMjDaDk=",
    publicKey:
      "BEzf4ciIL58K7d3JCIzp18uI5dq4KsNXpJegmgtP/e7pYLDlKF8Hpv7rWd7T0YFVh+FbZVJSkCiWsh7iF2CQ3Co=",
    x509PublicKey:
      "MIIBMTCB6gYHKoZIzj0CATCB3gIBATArBgcqhkjOPQEBAiB/////////////////////////////////////////7TBEBCAqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqYSRShRAQge0Je0Je0Je0Je0Je0Je0Je0Je0Je0Je0JgtenHcQyGQEQQQqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq0kWiCuGaG4oIa04B7dLHdI0UySPU1+bXxhsinpxaJ+ztPZAiAQAAAAAAAAAAAAAAAAAAAAFN753qL3nNZYEmMaXPXT7QIBCANCAARM3+HIiC+fCu3dyQiM6dfLiOXauCrDV6SXoJoLT/3u6WCw5ShfB6b+61ne09GBVYfhW2VSUpAolrIe4hdgkNw",
    nonce: "6IUe5wpHdJF/njHrhD9viI4defvinLoHsJXhcOkdl7s=",
  });
  const [noRecord, setNoRecord] = useState(false);
  const { Search } = Input;
  const user = {
    UserId: UserId,
  };
  useEffect(() => {
    const filePath = DECODEBASEData.filePath;
    if (filePath) {
      const fileURL = filePath;
      let alink = document.createElement("a");
      alink.target = "_blank";
      alink.href = fileURL;
      alink.download = "LPLReport.pdf";
      alink.click();
      window.location.reload(false);
    }

    return () => {};
  }, [DECODEBASEData]);
  useEffect(() => {
    const responseData = dataDecryption;
    if (responseData && responseData?.decryptedData) {
      const presentedForm = responseData.decryptedData;
      // console.log(presentedForm.entry)
      decodeBase64(presentedForm.entry);
    }
    return () => {};
  }, [dataDecryption]);

  useEffect(() => {
    // console.log("dat33", hiuConsentArtifactRequested);
  }, [hiuConsentArtifactRequested]);

  const decodeBase64 = async (item) => {
    item.map(async function (val, index) {
      if (val?.resource?.content?.data) {
        var presentedForm = val?.resource?.content.data;
        let _data = {};
        _data.stringToDecode = presentedForm;
        _data.customToken = true;
        decodeBase(_data);
      } else {
        // console.log('No presentedForm found')
      }
    });
  };

  const patientDetail = () => {
    let params = {
      healthId: values.healthId,
      UserId: UserId,
    };
    fetchgetCardsLogsSearch(params, {
      onSuccess: (res) => {
        let data = res.data?.result;
        if (data?.length > 0) {
          setNoRecord(false);
          navigate(`/hip/report-detail?healthId=${data[0]?.health_id}`);
        } else {
          setNoRecord(true);
        }
      },
    });
  };
  const downloadReport = async (item) => {
    var fhirData = item?.fhir_data ? JSON.parse(item?.fhir_data) : null;

    if (fhirData && fhirData?.decryptedData?.entry) {
      // decodeBase64(fhirData?.decryptedData?.entry)
      fhirData.customToken = true;
      // convertBase64Download(_data);
    } else if (fhirData && fhirData.entry) {
      // fhirData.customToken = false;
    } else {
      var rawData = item || "{}";
      let downloadReport = {
        artefactId: `${rawData?.response_request_id || ""}`,
      };
      let _data = { ...downloadReport };
      _data.customToken = true;

      getDownloadReport(_data);
    }
    return false;
  };
  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    fetchhiuConsentArtifactRequested({ ...filter });
    return () => {};
  }, [filter]);

  const expireDateTime = (expiryDate) => {
    var expiryDateTimeMS = moment(expiryDate).valueOf();
    var currentDateTimeMS = moment(currentDate).valueOf();
    //console.log(expiryDateTimeMS, ':::::::: -- :::', currentDateTimeMS);
    //console.log(expiryDate, ':::::::: -- :::', currentDate);
    //const date = moment(expiryDate, 'YYYY-MM-DD HH:mm:ss');
    //console.log(date, ':::::::: -- :::', currentDate);

    //console.log(currentDate);
    if (expiryDateTimeMS < currentDateTimeMS) {
      return true;
    } else {
      return false;
    }
  };
  const handleNotify = (item) => {
    var rawData = item?.response_raw_data
      ? JSON.parse(item?.response_raw_data || "{}")
      : null;
    //console.log("Testddd--");
    //console.log(item);
    var patient_data = JSON.parse(item?.ConsentRquestInitiateLog?.raw_data);
    //console.log("Test--");
    //console.log(patient_data);
    //console.log(patient_data?.consent?.permission?.dateRange?.from || "{}");
    let payload = {
      hiRequest: {
        consent: {
          id: `${rawData?.consentRequest?.id || ""}`,
        },
        dateRange: {
          from: `${
            moment
              .utc(patient_data?.consent?.permission?.dateRange?.from)
              .format("YYYY-MM-DD") || ""
          }`,
          to: `${
            moment
              .utc(patient_data?.consent?.permission?.dateRange?.to)
              .format("YYYY-MM-DD") || ""
          }`,
        },
        dataPushUrl:
          "https://abym.in/dev-url/abha/whatsapp_api_v1/ServicesLPL/callBackURL?artId=" +
          rawData?.consent?.consentDetail?.consentId,
        keyMaterial: {
          cryptoAlg: "ECDH",
          curve: "Curve25519",
          dhPublicKey: {
            expiry: `${
              moment.utc(patient_data?.consent?.permission?.expiry_date_time) ||
              ""
            }`,
            parameters: "Curve25519/32byte random key",
            keyValue: keyMaterial?.x509PublicKey,
          },
          nonce: keyMaterial?.nonce,
        },
      },
    };
    let _data = { ...payload };
    _data.customToken = true;

    KeyMaterialRequest(_data);
  };
  const onChange = (pagination, filters, sorter, extra) => {
    // console.log("params", pagination, filters, sorter, extra);
  };
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },

    {
      title: "ABHA Address",
      dataIndex: "abha_address",
      key: "id",
      className: "table_status_col",
      //   defaultFilteredValue: [healthId || ""],
      //   filters: [
      //     {
      //       text: healthId,
      //       value: healthId
      //     }
      //   ],

      //   render: (value, item, index) => {
      //     return (
      //       <span>{item?.abha_address}</span>
      //       // console.log(item?.ConsentRquestInitiateLog?.abha_address)
      //     );
      //   },
      //   onFilter: (item, record) =>
      //     record.ConsentRquestInitiateLog?.abha_address.indexOf(item) === 0
    },
    // {
    //   title: "Patient Name",
    //   dataIndex: "id",
    //   key: "id",
    //   className: "table_status_col",
    //   render: (value, item, index) => {
    //     let patient_data = item?.ConsentRquestInitiateLog?.patient_info
    //       ? JSON.parse(item?.ConsentRquestInitiateLog?.patient_info)
    //       : null;
    //     return (
    //       <span>{patient_data?.patient_name}</span>
    //       //  console.log(patient_data?.patient_name)
    //     );
    //   }
    // },
    {
      title: "Requester",
      dataIndex: "requester",
      key: "requestor",
      className: "text-capitalize",
      //   render: (value, item, index) => {
      //     let requester_data = item?.ConsentRquestInitiateLog?.patient_info
      //       ? JSON.parse(item?.ConsentRquestInitiateLog?.requestor_info)
      //       : null;
      //     return <span>{requester_data?.name}</span>;
      //   }
    },
    {
      title: "Requested For",
      dataIndex: "requested_for",
      key: "requested_for",
      className: "text-capitalize",
      render: (value, item, index) => {
        // let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //   ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //   : null;
        // let RequestedData = patient_data?.consent?.hiTypes.map(
        //   (hiType, index) => <li key={index}>{hiType}</li>
        // );
        return (
          <ul className="hiTypes">{item.requested_for}</ul>
          // console.log(RequestedData)
        );
      },
    },
    {
      title: "Requested HI Types",
      dataIndex: "hi_types",
      key: "hi_types",
      className: "text-capitalize hiTypes_column",
      render: (value, item, index) => {
        let types = [];
        try {
          types = value ? JSON.parse(value) : [];
        } catch (e) {
          console.error("Invalid hi_types format", e);
          types = [];
        }

        return types.length > 0 ? (
          <div
            className="hiTypes_scroll"
            style={{ maxHeight: "100px", overflowY: "scroll" }}
          >
            <ul className="hiTypes">
              {types.map((hiType, idx) => (
                <li key={idx}>{hiType}</li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        );
      },
    },
    {
      title: "From",
      dataIndex: "from_date",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>{moment(item.from_date).format("DD-MM-YYYY")}</>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
    },
    {
      title: "To",
      dataIndex: "to_date",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>{moment(item.to_date).format("DD-MM-YYYY")}</>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
      //   render: (value, item, index) => {
      //     let patient_data = item?.ConsentRquestInitiateLog?.raw_data
      //       ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
      //       : null;
      //     return (
      //       <>
      //         {moment
      //           .utc(patient_data?.consent?.permission?.dateRange?.to)
      //           .format("DD-MM-YYYY")}
      //       </>
      //     );
      //   }
    },
    {
      title: "Expiry",
      dataIndex: "expiry_date",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>{moment.utc(item.expiry_date).format("DD-MM-YYYY HH:mm")}</>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
      //   render: (value, item, index) => {
      //     let patient_data = item?.ConsentRquestInitiateLog?.raw_data
      //       ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
      //       : null;

      //     return (
      //       <>
      //         {moment(patient_data?.consent?.permission?.expiry_date_time).format(
      //           "DD-MM-YYYY hh:mm A"
      //         )}
      //       </>
      //     );
      //   }
    },

    {
      title: "Consent Status",
      dataIndex: "consent_status",
      key: "consent_status",
      className: "text-capitalize",
      render: (value, record, index) => {
        var expiryDateTime = null;
        var d = null;
        if (record?.ConsentRquestInitiateLog) {
          const responseData = JSON.parse(
            record?.ConsentRquestInitiateLog?.raw_data
          );
          if (responseData) {
            expiryDateTime =
              responseData?.consent?.permission?.expiry_date_time;
            if (expiryDateTime) {
              // setisExpired(expireDateTime(expiryDateTime));
              d = expireDateTime(expiryDateTime);
            }
          }
        }
        return record?.consent_status == "DENIED" ? (
          <span style={{ color: "red" }}>{record?.consent_status}</span>
        ) : record?.consent_status != "" &&
          record?.consent_status != "DENIED" &&
          expireDateTime(expiryDateTime) == true ? (
          <span style={{ color: "red" }}>EXPIRED</span>
        ) : record?.consent_status == "EXPIRED" ? (
          <span style={{ color: "red" }}>{record?.consent_status}</span>
        ) : record?.consent_status == "GRANTED" ? (
          <span style={{ color: "green" }}>{record?.consent_status}</span>
        ) : record?.consent_status == "REQUEST PENDING" ? (
          <span style={{ color: "orange" }}>{record?.consent_status}</span>
        ) : (
          <span>{record?.consent_status}</span>
        );
      },
    },
    {
      title: "Artifact/Facility Count",
      dataIndex: "consent_artifacts",
      key: "requestor",
      className: "text-capitalize",
      render: (value, item, index) => {
        return <>{JSON.parse(item.consent_artifacts)?.length}</>;
      },
    },
    {
      title: "Grant DateTime",
      dataIndex: "grant_date_time",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>
            {item?.grant_date_time &&
              moment.utc(item.grant_date_time).format("DD-MM-YYYY HH:mm")}
          </>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
    },
    {
      title: "Deny DateTime",
      dataIndex: "deny_date_time",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>
            {item?.deny_date_time &&
              moment.utc(item?.deny_date_time).format("DD-MM-YYYY HH:mm")}
          </>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
    },
    {
      title: "Revoke DateTime",
      dataIndex: "revoke_date_time",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          // <>{item?.revoke_date_time && moment(item?.revoke_date_time).format("DD-MM-YYYY hh:mm A")}</>
          item?.revoke_date_time && (
            <>
              {moment.utc(item.revoke_date_time).format("DD-MM-YYYY HH:mm")}
            </>
          )
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
    },
    {
      title: "View",
      dataIndex: "consent_status ",
      key: "consent_status",
      className: "abha-link-action",
      render: (value, item, record) => {
        // console.log(
        //   item.consent_artifacts,
        //   "==",
        //   typeof item.consent_artifacts
        // );

        let id = item.consent_artifacts
          ? JSON.parse(item?.consent_artifacts)[0]?.id
          : "";
        var expiryDateTime = null;
        // var d = null;
        // console.log('Testtt:::',item);
        // console.log('fsdgfsf',record);
        // console.log("test");
        if (item?.ConsentRquestInitiateLog) {
          const responseData = JSON.parse(
            item?.ConsentRquestInitiateLog?.raw_data
          );
          if (responseData) {
            expiryDateTime =
              responseData?.consent?.permission?.expiry_date_time;
          }
        }
        return item?.consent_status == "GRANTED" &&
          expireDateTime(expiryDateTime) == false ? (
          <>
            {" "}
            <Tooltip placement="top" title={"Fetch HIP"}>
              <AntLoadingButton
                className="view-btn"
                type="primary"
                onClick={() =>
                  handleFetchArtifactDetail(id, item["x-request-id"])
                }
              >
                <LinkOutlined />
              </AntLoadingButton>
            </Tooltip>
          </>
        ) : item.consent_status == "DENIED" ? (
          <span style={{ color: "red" }}>Can't View </span>
        ) : item.consent_status == "EXPIRED" ? (
          <span style={{ color: "red" }}>Consent Expired</span>
        ) : item.consent_status == "REVOKED" ? (
          <span style={{ color: "red" }}>Consent Revoked</span>
        ) : (
          ""
        );
      },
    },

    // {
    //     title: 'View Artificat',
    //     dataIndex: 'Status',
    //     key: 'Status',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             // <><Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.response_raw_data || "{}")); setModal1Open(true); } }>Data</Button></>
    //             <Link to="/hiu-consent-artifact-details"> View Artifacts</Link>
    //         )
    //     }
    // },
    {
      title: "Requested At",
      dataIndex: "created_at",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>{moment.utc(item.createdAt).format("DD-MM-YYYY hh:mm A")}</>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
    },
    {
      title: "Last Updated",
      dataIndex: "updated_at",
      key: "id",
      className: "text-capitalize",
      render: (value, item, index) => {
        //   let patient_data = item?.ConsentRquestInitiateLog?.raw_data
        //     ? JSON.parse(item?.ConsentRquestInitiateLog?.raw_data)
        //     : null;
        return (
          <>{moment.utc(item.updatedAt).format("DD-MM-YYYY hh:mm A")}</>
          // console.log(patient_data?.consent?.permission?.dateRange?.from)
        );
      },
    },
  ];

  return (
    <div>
      {loader ? <Loader /> : ""}
      {loader1 ? <Loader /> : ""}
      <Row gutter={[10, 10]} align={"middle"}>
        <Col span={24}>
          <HeadingBack
            title={"Consent Artifact Requested"}
            subHeading={`Records ${totalhiuConsentArtifactRequested || 0}`}
          />
        </Col>
        <Col span={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            searchHide={false}
          />
          <div className="flex justify-content-end align-items-center pr-10 hiu-dash hiu-ask-btn">
            {rights.Add && (
              <Tooltip title="Ask Report">
                <span className="" onClick={() => setaskReport(true)}>
                  <img
                    src={IMAGES.ReqIcon}
                    width={40}
                    height={40}
                    className="cursor-pointer"
                  />
                </span>
              </Tooltip>
            )}
          </div>
        </Col>
        {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey={(row) => row?.Id ?? row?.id}
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          bordered
          columns={columns}
          onChange={onChange}
          dataSource={
            Array.isArray(hiuConsentArtifactRequested) &&
            hiuConsentArtifactRequested?.length > 0
              ? hiuConsentArtifactRequested
              : []
          }
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              setPage(current);
            },
            hideOnSinglePage: true,
            /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
          }}
        />
      </div>

      <Modal
        style={{
          top: 20,
        }}
        open={modal1Open}
        onOk={() => setModal1Open(false)}
        onCancel={() => {
          setRaw({});
          setModal1Open(false);
        }}
        footer={null}
      >
        <pre>{JSON.stringify(raw, null, 2)}</pre>
      </Modal>
      <Modal
        style={{
          top: 20,
        }}
        open={askReport}
        onOk={() => setaskReport(false)}
        onCancel={() => setaskReport(false)}
        footer={null}
      >
        <Search
          placeholder="ABHA Address"
          allowClear
          enterButton="Search"
          size="large"
          className="askSearch"
          onChange={(e) => handleChange("healthId", e.target.value)}
          onSearch={patientDetail}
          value={values?.healthId}
        />
        {noRecord && <div className="text-center fw-600">No Record Found</div>}
      </Modal>
    </div>
  );
};

export default ConsentArtifactRequested;
